import '../../assets/power-backup.svg.mjs';
import icon__default from "../../../../assets/power-backup.svg";
"use strict";
const generalRedundancy = {
  id: "generalRedundancy",
  title: "generalRedundancy.title",
  // todo add didzis about this icon as well for use with shadow mode
  icon: icon__default
};
export { generalRedundancy };
//# sourceMappingURL=generalRedundancy.mjs.map
